import { theme } from 'antd';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { RootState } from '@/redux/store';
import { currentEnvironment } from '@/utils/url';

type Props = {
  className?: string;
  loading?: boolean;
  collapsed?: boolean;
};

function Logo(props: Props) {
  const className = classNames(props.className || '');
  const currentTheme = useSelector(
    (state: RootState) => state.appSettings.currentTheme
  );
  const {
    token: {},
  } = theme.useToken();

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={props.collapsed ? '0 0 500 360' : '0 0 1800 360'}
      height="100%"
      fill={currentTheme === 'dark' ? 'white' : 'black'}
    >
      <path d="M255.21,62.93c-9.98,3.45-19.38,8.37-27.9,14.61-8.41,6.11-15.82,13.49-21.98,21.87-5.72,7.77-10,16.51-12.62,25.79-15.23,.11-30.34,2.73-44.72,7.76-15.09,5.22-29.3,12.67-42.18,22.1-12.72,9.25-23.93,20.41-33.24,33.09-8.7,11.75-15.21,24.97-19.22,39.02h111.24l28.13-101.97h73.55l18.52-67.42c-10.07,.08-20.06,1.81-29.57,5.14Z" />
      {!props.collapsed && (
        <g>
          <path d="M330.62,161.7c0-40.01,27.28-67.55,66.51-67.55,33.51,0,57.16,17.41,61.57,45.2l-31.95,6.24c-2.34-13.77-13.25-23.12-28.58-23.12-20.26,0-33.51,15.33-33.51,39.23s13.25,39.23,33.51,39.23c15.33,0,25.46-8.31,28.58-22.34l31.95,6.5c-4.94,27.54-28.58,44.17-61.57,44.17-39.23,0-66.51-27.54-66.51-67.55Z" />
          <path d="M472.96,161.72c0-38.97,28.58-67.55,68.33-67.55s68.33,28.58,68.33,67.55-28.58,67.55-68.33,67.55-68.33-28.58-68.33-67.55Zm103.66,0c0-23.38-14.29-39.23-35.33-39.23s-35.33,15.85-35.33,39.23,14.03,39.23,35.33,39.23,35.33-15.85,35.33-39.23Z" />
          <path d="M626.92,96.23h32.73v19.75c8.31-12.73,23.12-21.82,41.57-21.82,28.58,0,47.8,18.71,47.8,47.28v85.73h-32.73v-77.94c0-15.33-9.61-25.98-24.94-25.98-20,0-31.7,17.15-31.7,46.5v57.42h-32.73V96.23Z" />
          <path d="M771.38,96.23h32.73v19.75c8.31-12.73,23.12-21.82,41.57-21.82,28.58,0,47.8,18.71,47.8,47.28v85.73h-32.73v-77.94c0-15.33-9.61-25.98-24.94-25.98-20,0-31.7,17.15-31.7,46.5v57.42h-32.73V96.23Z" />
          <path d="M1040.72,170.28h-97.16c2.86,19.75,15.59,31.44,34.29,31.44,15.33,0,26.24-7.27,29.62-20l30.66,8.31c-7.27,24.68-30.14,39.23-60.79,39.23-43.39,0-66.51-33.51-66.51-67.55s21.3-67.55,64.69-67.55,65.73,32.73,65.73,63.13c0,4.68-.26,10.39-.52,12.99Zm-34.55-23.9c-1.56-15.59-11.69-27.28-30.66-27.28-16.11,0-27.54,9.61-31.18,27.28h61.83Z" />
          <path d="M1055.56,161.7c0-40.01,27.28-67.55,66.51-67.55,33.51,0,57.16,17.41,61.57,45.2l-31.95,6.24c-2.34-13.77-13.25-23.12-28.58-23.12-20.26,0-33.51,15.33-33.51,39.23s13.25,39.23,33.51,39.23c15.33,0,25.46-8.31,28.58-22.34l31.95,6.5c-4.94,27.54-28.58,44.17-61.57,44.17-39.23,0-66.51-27.54-66.51-67.55Z" />
          <path d="M1261.29,229.25c-26.5,0-46.24-14.29-46.24-44.94v-60.53h-22.08v-27.54h22.08V57.79h32.73v38.45h32.2v27.54h-32.2v57.41c0,12.47,6.75,19.23,16.89,19.23,4.94,0,10.65-.78,15.33-3.12l-.02,29.35c-6.65,1.94-11.15,2.6-18.69,2.6Z" />
          <path d="M1400.09,212.1v15.07h-32.73V57.79h32.73v53c7.53-9.87,21.56-16.63,37.93-16.63,38.71,0,61.83,27.54,61.83,67.55s-23.12,67.55-62.35,67.55c-16.11,0-30.92-6.75-37.41-17.15Zm67.29-50.4c0-23.64-13.77-39.23-34.55-39.23s-34.81,15.59-34.81,39.23,13.77,39.23,34.81,39.23,34.55-15.59,34.55-39.23Z" />
          <path d="M1637.61,227.17h-32.73v-19.74c-8.31,12.73-23.12,21.82-41.57,21.82-28.32,0-47.8-18.71-47.8-47.28V96.23h32.73v77.94c0,15.33,9.61,25.98,24.94,25.98,20.26,0,31.7-17.15,31.7-46.5v-57.42h32.73V227.17Z" />
          <path d="M1653.1,190.54l26.76-10.91c3.9,13.25,14.03,24.16,30.4,24.16,12.21,0,20.26-6.5,20.26-14.81,0-24.68-71.44-8.57-71.44-58.19,0-20.52,17.93-36.63,46.5-36.63,25.46,0,47.02,12.99,52.74,31.96l-26.5,11.17c-3.64-12.47-15.07-18.96-25.72-18.96s-17.41,4.42-17.41,11.95c0,23.12,71.96,4.68,71.96,58.19,0,22.6-20.26,40.79-50.4,40.79-31.69,0-50.66-19.48-57.15-38.71Z" />
        </g>
      )}
      {!props.loading &&
        !props.collapsed &&
        currentEnvironment !== 'Production' && (
          <text
            x="50%"
            y="340"
            textAnchor="middle"
            fontSize="120"
            fill={currentTheme === 'dark' ? 'white' : 'black'}
          >
            {currentEnvironment}
          </text>
        )}
    </svg>
  );
}

export default Logo;
